import { reducerWrapper } from '../../main/support/utils';

import { GET_USER, GET_ROLE, UPDATE_USER, UPDATE_USER_SETTINGS } from '../actions/UserActions';

export const INIT_STATE = {
  loading: false,
  settingsLoading: false,
  error: null,
  data: null,
  access_role_id: null,
};

function Handler(state, action) {
  switch (action.type) {
    case GET_USER.response:
    case UPDATE_USER.response:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.data,
      };
    case UPDATE_USER_SETTINGS.request:
      return {
        ...state,
        settingsLoading: true,
        error: null,
      };
    case UPDATE_USER_SETTINGS.response:
      return {
        ...state,
        settingsLoading: false,
        error: null,
        data: action.data,
      };

    case GET_ROLE.response:
      return {
        ...state,
        loading: false,
        error: null,
        access_role_id: action.data && action.data.access_role_id,
      };

    default:
      return state;
  }
}

const UserReducer = reducerWrapper(INIT_STATE, Handler, {
  request: [GET_USER, GET_ROLE, UPDATE_USER],
  error: [GET_USER, GET_ROLE, UPDATE_USER],
  resetOn: ['APP_CHANGE'],
});

export default UserReducer;
